"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMembersView = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
require("./index.scss");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_router_dom_1 = require("react-router-dom");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var index_1 = require("./Users/UserGroups/index");
var FolderPermissions_1 = require("./FolderPermissions");
var projectMembersActions = require("@caddigital/sok-reducers/lib/actions/project/members");
var projectUsersActions = require("@caddigital/sok-reducers/lib/actions/project/users");
var activatedFormsActions = require("@caddigital/sok-reducers/lib/actions/sokosite/activatedForms");
var ProjectHomeAtions = require("@caddigital/sok-reducers/lib/actions/project/home");
var Types = require("types");
var translate_1 = require("utils/translate");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Parties_1 = require("./Parties");
var project_1 = require("reducers/selectors/project");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var _a = (0, project_1.selectAccessDetails)(state), isSuperAdmin = _a.isSuperAdmin, accessFolderPermission = _a.accessFolderPermission, accessUserManagement = _a.accessUserManagement;
    var folderPermissionsChanged = state.project.permissions.changes.length > 0;
    return {
        folderPermissionsChanged: folderPermissionsChanged,
        currentTab: state.project.members.currentTab,
        selectedLanguage: selectedLanguage,
        isSuperAdmin: isSuperAdmin,
        accessFolderPermission: accessFolderPermission,
        accessUserManagement: accessUserManagement,
        customerName: state.project.currentProject.status === 'FETCHED'
            ? state.project.currentProject.project.customerName
            : ''
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    clearAll: function () {
        dispatch(projectMembersActions.clearState());
        dispatch(projectUsersActions.clearState());
        dispatch(ProjectHomeAtions.clear());
    },
    onChangeTab: function (tab) {
        dispatch(projectMembersActions.setTab(tab));
    },
    fetchProjectUserGroups: function (id) {
        return dispatch(projectMembersActions.UsergroupList.fetchRequest('PROJECT', id));
    },
    fetchProjectUserList: function (id) {
        return dispatch(projectUsersActions.fetchProjectUserListRequest(id));
    },
    fetchActivatedForms: function (projectId) {
        return dispatch(activatedFormsActions.fetchRequest(projectId));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var TeamMembersView = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { key: 'main-content', className: 'content-wrapper-content' },
        React.createElement("div", { className: 'project-team-members-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/") + props.currentProject.id }, props.currentProject.name),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/projectname/teamMembers'))),
                React.createElement("div", { className: 'users-content' },
                    React.createElement(sok_ui_1.Tabs, { activeIndex: props.currentTab, className: 'tabsbar', onClick: function (index) {
                            if (props.folderPermissionsChanged) {
                                props.setWarningModal({
                                    content: [
                                        (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textNotice1'),
                                        (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textNotice2')
                                    ],
                                    action: function () { return props.onChangeTab(index); }
                                });
                            }
                            else {
                                props.onChangeTab(index);
                            }
                        } },
                        props.accessUserManagement ? (React.createElement("div", { className: 'users-tab', key: "users-tab" }, (0, translation_1.getLocalization)('userfront/project/teamMembers/users'))) : undefined,
                        props.accessFolderPermission ? (React.createElement("div", { className: 'folder-permissions-tab', key: "folder-permissions-tab" }, (0, translation_1.getLocalization)('userfront/project/teamMembers/folderPermissions'))) : undefined,
                        props.accessFolderPermission ||
                            props.currentProject.showPartiesTab === true ? (React.createElement("div", { className: 'users-tab', key: "parties-tab" }, (0, translation_1.getLocalization)('userfront/project/teamMembers/parties-tab'))) : undefined,
                        React.createElement("span", null),
                        React.createElement("span", null),
                        React.createElement("span", null)),
                    [
                        props.accessUserManagement ? (React.createElement("div", { className: 'users-content', key: 'users-content' },
                            React.createElement(index_1.default, __assign({}, props)))) : undefined,
                        props.accessFolderPermission ? (React.createElement("div", { className: 'folder-permissions-content', key: 'folder-permissions-content' },
                            React.createElement(FolderPermissions_1.default, __assign({}, props)))) : undefined,
                        props.accessFolderPermission ||
                            props.currentProject.showPartiesTab === true ? (React.createElement("div", { className: 'users-content', key: 'users-content' },
                            React.createElement(Parties_1.default, __assign({}, props)))) : undefined
                    ].filter(function (x) { return !!x; })[props.currentTab]),
                React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.warningModal !== null, close: function () { return props.setWarningModal(null); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                        React.createElement(ConfirmDialog_1.Exclamation, null),
                        React.createElement("div", null,
                            React.createElement("div", { className: 'title please-confirm-text' },
                                React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                            React.createElement("div", { className: 'text' }, ((props.warningModal && props.warningModal.content) ||
                                []).map(function (x) { return (React.createElement("p", null, x)); })))), footer: React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                                if (props.warningModal) {
                                    props.warningModal.action();
                                    props.setWarningModal(null);
                                }
                            } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setWarningModal(null); } })) })))))); };
exports.TeamMembersView = TeamMembersView;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('warningModal', 'setWarningModal', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchProjectUserGroups(this.props.currentProject.id);
        this.props.fetchProjectUserList(this.props.currentProject.id);
        if (this.props.currentProject &&
            this.props.currentProject.perm &
                (acl.SUPER_ADMIN_GRANT & ~acl.FEATURE_MASK)) {
            this.props.fetchActivatedForms(String(this.props.currentProject.id));
        }
    },
    componentWillUnmount: function () {
        this.props.clearAll();
    }
}), recompose_1.pure);
exports.default = enhance(exports.TeamMembersView);
